import { useState } from "react";

type StandingsTablesProps = {
  withContainer?: boolean;
  brasileiraoHeight?: number;
  internacionalHeight?: number;
};

export default function StandingsTables({
  withContainer = true,
  brasileiraoHeight = 800,
  internacionalHeight = 1500,
}: StandingsTablesProps) {
  const [activeTab, setActiveTab] = useState<"brasileirao" | "internacional">("brasileirao");
  const contentClassName = withContainer ? "w-full px-4 md:px-8" : "w-full";

  return (
    <section className="w-full py-8 md:py-12">
      <div className={contentClassName}>
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <div className="flex items-center gap-2">
            <i className="ri-bar-chart-2-line text-alvinegro-black text-xl"></i>
            <h2 className="font-serif font-bold text-2xl md:text-3xl text-alvinegro-black">
              Classificação
            </h2>
          </div>
        </div>

        {/* Tab Switcher */}
        <div className="flex gap-2 mb-6">
          <button
            onClick={() => setActiveTab("brasileirao")}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
              activeTab === "brasileirao"
                ? "bg-alvinegro-black text-white"
                : "bg-alvinegro-light text-alvinegro-dark hover:bg-alvinegro-border"
            }`}
          >
            Brasileirão
          </button>
          <button
            onClick={() => setActiveTab("internacional")}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
              activeTab === "internacional"
                ? "bg-alvinegro-black text-white"
                : "bg-alvinegro-light text-alvinegro-dark hover:bg-alvinegro-border"
            }`}
          >
            Internacional
          </button>
        </div>

        {/* Brasileirão - Widget API Futebol */}
        {activeTab === "brasileirao" && (
          <div className="bg-white rounded-2xl overflow-hidden">
            <iframe
              src="https://widget.api-futebol.com.br/render/widget_5bb84a9e59020d14"
              title="API Futebol - Classificação Brasileirão"
              style={{
                border: "0",
                background: "transparent",
                width: "100%",
                height: `${brasileiraoHeight}px`,
              }}
              scrolling="no"
              referrerPolicy="unsafe-url"
            />
          </div>
        )}

        {activeTab === "internacional" && (
          <div className="bg-white rounded-2xl overflow-hidden">
            <iframe
              src="https://widget.api-futebol.com.br/render/widget_6651f669e7b0950e"
              title="API Futebol - Widget Internacional"
              style={{
                border: "0",
                background: "transparent",
                width: "100%",
                height: `${internacionalHeight}px`,
              }}
              scrolling="no"
              referrerPolicy="unsafe-url"
            />
          </div>
        )}
      </div>
    </section>
  );
}
